module.exports = __webpack_public_path__ + "media/pong-gameplay.76aec737.mp4";